import { WidgetsFaqsMain } from '@/widgets/faqs';

export const PagesFaqsMain = () => <WidgetsFaqsMain />;
